import React from 'react';
import {
    VerticalTimeline,
    VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { MdSchool } from 'react-icons/md';

const Timeline = ({ items }) => {
    const timeline_theme = {
        future: {
            iconStyle: {
                background: 'rgb(0, 204, 102)',
                color: '#fffF',
            },
        },
        current: {
            iconStyle: {
                background: 'rgb(33, 150, 243)',
                color: '#fffF',
            },
        },
        past: {
            iconStyle: {
                background: 'rgb(112,128,144)',
                color: '#fffF',
            },
        },
    };

    return (
        <VerticalTimeline>
            {items.list.map((item, idx) => {
                return (
                    <VerticalTimelineElement
                        key={idx}
                        className='vertical-timeline-element--work '
                        {...timeline_theme[item.type]}
                        date={item.date}
                        contentStyle={{
                            backdropFilter: 'blur(8px)',
                            background: 'rgba(255, 255, 255,0.3)',
                            color: '#fff',
                        }}
                        contentArrowStyle={{
                            borderRight: '7px solid rgba(255, 255, 255,0.3)',
                        }}
                        icon={<MdSchool />}
                    >
                        <h3 className='vertical-timeline-element-title'>
                            {item.cardTitle}
                        </h3>
                        <h4 className='vertical-timeline-element-subtitle'>
                            {item.cardSubtitle}
                        </h4>
                        <p>{item.cardDetailedText}</p>
                        {/* <img
                    className='my-4 rounded-[16px] max-h-60'
                    src={item.imgurl}
                    alt=''
                /> */}
                    </VerticalTimelineElement>
                );
            })}
        </VerticalTimeline>
    );
};

export default Timeline;
